module.exports = __webpack_public_path__ + "img/12.b8b3a48.png";